const angular = require('angular');

module.exports = function restAngularConfiguration(RestangularProvider) {
    RestangularProvider.setBaseUrl('/apis/ui');
    RestangularProvider.setRestangularFields({ id: 'Stockcode' });
    RestangularProvider.setDefaultHeaders({ __RequestVerificationToken: angular.element('input[name="__RequestVerificationToken"]').attr('value') || 'no request verification token' });
};



// WEBPACK FOOTER //
// ./src/configuration/restangular.js